import { getItem } from '@/utils/storage'

export const getHeaders = () => {
    return {
        'x-access-token': getItem(localStorage, 'token'),
        'x-sistema': 'IM',
        'x-sistema-legivel': 'Inteligência de Mercado',
        'x-versao': import.meta.env.VITE_VERSION,
    }
}
